import http from '../const/http-common'

const chat = (info) => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.post('/v1/user/chat/chat', info, { headers });
}

const getHierarchy = () => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  return http.get('/v1/user/chat/hierarchy', { headers });
}

const getHistory = (info) => {
  const { source, session } = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  
  return http.post('/v1/user/chat/get_session', {source, session}, { headers });
}

const getCubeHistory = (info) => {
  const { source, cube, session } = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  
  return http.post('/v1/user/chat/get_cube_session', {source, cube, session}, { headers });
}

const saveSession = (info) => {
  const { source, session, data } = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  
  return http.post('/v1/user/chat/save_session', {source, session, data}, { headers });
}

const renameSession = (info) => {
  const { source, origin, next } = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  
  return http.put('/v1/user/chat/rename_session', {source, origin, next}, { headers });
}

const removeSession = (info) => {
  const { source, session } = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  
  return http.delete('/v1/user/chat/remove_session', {  
    headers,        // Attach headers properly  
    data: { source, session }  // Properly structured payload for Axios DELETE  
  });  
}

const parseQuery = (info) => {
  const { query } = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  
  return http.post('/v1/user/chat/parse-query', {query}, { headers });
}

const chatService = {
  chat,
  getHierarchy,
  getHistory,
  getCubeHistory,
  saveSession,
  renameSession,
  removeSession,
  parseQuery
}

export default chatService